//Customizable Area Start
'use strict';

const baseURL = 'https://backend.upmed.tech';
Object.defineProperty(exports, '__esModule', {
  value: true
});

exports.baseURL = baseURL;
//Customizable Area End
